import { Modal } from "@commonlibs";
import styled, { css } from "styled-components";

export const ModalRoot = styled(Modal)(
    ({ theme }) => css`
        position: relative;
        padding: 0;
        width: 37rem;
        max-width: 90vw;
        max-height: 82vh;
        border-radius: ${theme.borderRadiusLg};
        ${theme.breakpoints.down("mobile")} {
            height: unset;
        }
    `,
);
